import React from "react";

const Photo = ({
  width = 36,
  height = 36,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.7187 8.67811H7.88759V26.9054L19.9853 14.8051C20.2294 14.561 20.5605 14.4239 20.9058 14.4239C21.251 14.4239 21.5821 14.561 21.8262 14.8051L28.7187 21.7106V8.67811ZM5.28369 7.36705C5.28607 7.02513 5.42287 6.69787 5.66453 6.45597C5.90619 6.21407 6.23331 6.07695 6.57522 6.07422H30.0311C30.7446 6.07422 31.3226 6.65359 31.3226 7.36705V28.2164C31.3203 28.5584 31.1835 28.8856 30.9418 29.1275C30.7001 29.3694 30.373 29.5065 30.0311 29.5093H6.57522C6.23257 29.5089 5.90407 29.3726 5.66189 29.1301C5.41972 28.8877 5.28369 28.5591 5.28369 28.2164V7.36705ZM13.0954 16.4898C12.4048 16.4898 11.7425 16.2155 11.2541 15.7271C10.7658 15.2388 10.4915 14.5765 10.4915 13.8859C10.4915 13.1953 10.7658 12.533 11.2541 12.0447C11.7425 11.5563 12.4048 11.282 13.0954 11.282C13.786 11.282 14.4483 11.5563 14.9366 12.0447C15.4249 12.533 15.6993 13.1953 15.6993 13.8859C15.6993 14.5765 15.4249 15.2388 14.9366 15.7271C14.4483 16.2155 13.786 16.4898 13.0954 16.4898Z"
        fill="#133345"
      />
    </svg>
  );
};

export default Photo;
